var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-preview-box"},[_c(_vm.componentName,{tag:"component",attrs:{"info":_vm.info,"mode":_vm.mode || 1,"pre":_vm.pre},on:{"updateInfo":_vm.updateInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }